/* eslint-disable */
(function IIFE() {
    $('.b-clinic-prices__key_js_full-prices').click(function () {
        window.open($(this).data('speciality-link'), '_self')
    });
})();

(function IIFE() {
    $('.b-clinic-full-price__service_js_link').click(function () {
        window.open($(this).data('dtypelink'), '_blank');
    });
})();

(function IIFE() {
    const body = (attributes, descriptions) => {
        let result = '';

        attributes.forEach((attr, i) => {
            result += `<div class="b-popup__caption b-text-unit b-text-unit_color_dark b-text-unit_weight_bold">${attr}</div>
                   <div class="b-popup__description b-text-unit b-text-unit_color_dark">${descriptions[i]}</div>`
        });

        return result;
    };

    const template = (name, thumb, attributes, descriptions) => `
                    <div class="b-popup b-popup_equipment-attribute mfp-with-anim">
                            <div class="b-popup__title">${name}</div>
                        <div class="b-popup__body">
                            <div class="b-popup__image-wrap">
                                <img class="b-popup__image" src="${thumb}" alt="">
                            </div>
                            ${body(attributes, descriptions)}
                        </div>
                    </div>
                `;

    $('.b-clinic-full-price__equipment-box_js').each(function() {
        const name = $(this).data('name');
        const thumb = $(this).data('thumb');
        const effect = $(this).data('effect');
        const attributes = JSON.parse(JSON.stringify($(this).data('attributes')));
        const descriptions = JSON.parse(JSON.stringify($(this).data('descriptions')));

        $(this).click(function () {
            $(this).magnificPopup({
                removalDelay: 200,
                items: {
                    src: template(name, thumb, attributes, descriptions),
                    type: 'inline'
                },
                callbacks: {
                    beforeOpen: function () {
                        this.st.mainClass = 'mag-popup';
                        this.st.mainClass += ' ' + effect;
                    }
                }
            }).magnificPopup('open');
        })
    });
})();
